import { render } from "./ForgotPasswordReset.vue?vue&type=template&id=1fdfc4ce&scoped=true"
import script from "./ForgotPasswordReset.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordReset.vue?vue&type=script&lang=js"

import "./ForgotPasswordReset.vue?vue&type=style&index=0&id=1fdfc4ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdfc4ce"]])

export default __exports__